/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LearnWorldCategoryListResponseModel } from '../../models/learn-world-category-list-response-model';

export interface LearnWorldCategoriesGet$Params {
}

export function learnWorldCategoriesGet(http: HttpClient, rootUrl: string, params?: LearnWorldCategoriesGet$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<LearnWorldCategoryListResponseModel>> {
  const rb = new RequestBuilder(rootUrl, learnWorldCategoriesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<LearnWorldCategoryListResponseModel>;
    })
  );
}

learnWorldCategoriesGet.PATH = '/LearnWorld/Categories';
